module.exports = `
<div v-if="isopen" id="lookbook-popup" class="modal fade" ref="popup" style="display: block" :class="{'show': isopen}">
	<div class="mask" :class="{'active':isopen}" @click="closePopup"></div>
	<div class="modal-dialog" style="position: relative; z-index: 1050; max-width: 800px;">
		<div class="modal-content">
		    <div>
			    <div style="float: left; width: 50%; padding: 34px 0 34px 24px;"><div :style="'padding-bottom: 100%; height:0; background:url(' + igimg + '); background-size: cover; background-position: center;'"></div></div>
				<div style="float: left; width: 50%;">
					<div class="modal-header"><h4 class="modal-title">Shop This Look</h4><a @click.prevent="closePopup" class="close" href="#"><i class="icon-remove-x"></i></a></div>
					<div class="modal-body">
					  <div class="shopping-table" style="height: 245px; overflow: auto;">
					  	<shop-item :item="market" v-for="(market, index) in item" :key="index"></shop-item>
					  </div>
					</div>
					<div class="modal-footer">
						<a @click.prevet="addtocart" class="btn btn-primary btn-block" href="#">ADD TO CART</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
`;
